import { useAuth } from "../context/AuthContext";
import PlatformAdminDashboard from "./Home/PlatformAdminDashboard";
import CompanyAdminDashboard from "./Home/CompanyAdminDashboard";
import CompanyUserDashboard from "./Home/CompanyUserDashboard";
import UniversityAdminDashboard from "./Home/UniversityAdminDashboard";
import UniversityStudentDashboard from "./Home/UniversityStudentDashboard";
import ProfessionalDashboard from "./Home/ProfessionalDashboard";
import StudentDashboard from "./Home/StudentDashboard";

export default function Home() {
  const { user } = useAuth();

  // Determine which dashboard to show based on user roles
  const getUserRole = () => {
    if (!user || !user.roles || user.roles.length === 0) {
      return "professional"; // Default role
    }

    const roles = user.roles;

    if (roles.includes("platform_admin")) {
      return "platform_admin";
    } else if (roles.includes("company_admin")) {
      return "company_admin";
    } else if (roles.includes("company_user")) {
      return "company_user";
    } else if (roles.includes("university_admin")) {
      return "university_admin";
    } else if (roles.includes("university_student")) {
      return "university_student";
    } else if (roles.includes("professional")) {
      return "professional";
    } else if (roles.includes("student")) {
      return "student";
    }

    // Default fallback
    return "professional";
  };

  const role = getUserRole();

  // Render the appropriate dashboard based on role
  switch (role) {
    case "platform_admin":
      return <PlatformAdminDashboard />;
    case "company_admin":
      return <CompanyAdminDashboard />;
    case "company_user":
      return <CompanyUserDashboard />;
    case "university_admin":
      return <UniversityAdminDashboard />;
    case "university_student":
      return <UniversityStudentDashboard />;
    case "student":
      return <StudentDashboard />;
    case "professional":
      return <ProfessionalDashboard />;
    default:
      return <ProfessionalDashboard />;
  }
}
